import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { textEllipsis } from '@finect/tabular-utils/textEllipsis';
import { getFont } from '@finect/tabular-utils/getFont';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-1f3tmkh-0"
})(["padding:16px 6px;margin:0 10px;&:not(:first-child){border-top:1px solid ", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.terciaryL;
});
export var ContentBlock = styled.div.withConfig({
  displayName: "partials__ContentBlock",
  componentId: "sc-1f3tmkh-1"
})(["width:100%;max-width:calc(100% - 78px);margin-left:8px;"]);
export var AdviserTitle = styled.h3.withConfig({
  displayName: "partials__AdviserTitle",
  componentId: "sc-1f3tmkh-2"
})(["display:block;font-weight:700;color:", ";", ";", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.uiDDD;
}, getFont(0, 'compact'), textEllipsis);
export var AdviserOrganization = styled.h6.withConfig({
  displayName: "partials__AdviserOrganization",
  componentId: "sc-1f3tmkh-3"
})(["display:block;", ";font-weight:500;color:", ";", ";"], getFont('-1'), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.terciary;
}, textEllipsis);
export var BadgesContent = styled.div.withConfig({
  displayName: "partials__BadgesContent",
  componentId: "sc-1f3tmkh-4"
})(["display:flex;margin-top:4px;flex-flow:column;> div:not(:last-child){width:100%;margin-bottom:6px;}"]);
export var CertificationBadge = styled.div.withConfig({
  displayName: "partials__CertificationBadge",
  componentId: "sc-1f3tmkh-5"
})(["width:auto;padding:4px;border-radius:", ";margin-right:8px;background-color:", ";color:", ";user-select:none;", ";&:last-child{margin-right:0;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.borderRadius;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.uiD;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.terciaryLL;
}, getFont('-2', 'compact'));
export var InfoBlock = styled.div.withConfig({
  displayName: "partials__InfoBlock",
  componentId: "sc-1f3tmkh-6"
})(["", ";margin-top:16px;a span{font-weight:600;color:", ";text-decoration:none;}div{align-items:center;}div button{flex-grow:0;flex-shrink:0;font-size:11px;line-height:18px;}", ";"], getFont('-1'), function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.uiDDD;
}, maxMediaQueries.miniDesktop(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    div button {\n      margin-left: auto;\n    }\n  "]))));